import Event from '../hlsjs/events'; //Mactrix line added

import CryptoAesCbc from './CryptoAesCbc';

import { ErrorTypes, ErrorDetails } from '../hlsjs/errors';
import { logger } from '../hlsjs/utils/logger';

import ArrayHelper from '../helpers/ArrayHelper';

require('core-js/fn/promise');

class MactrixDecrypter {
	constructor(observer, config) {
		this.observer = observer;
		this.config = config;
		this.logEnabled = true;
		this.crypto = new CryptoAesCbc(); // super-duper-mactrix-crypto
	}

	isSync() {
		return (false); // we're async/Promise based.
	}

	decrypt(data, key, iv, callback) {

		// TODO: this.config.enableSoftwareAES
		let keyArray = ArrayHelper.makeUint8Array(key);
		let ivArray = ArrayHelper.makeUint8Array(iv);


		try {
			if (this.key !== key) {
				this.key = key;
				this.cryptoKey = this.crypto.createKey(keyArray);
			}

			this.cryptoKey
			.then((aesKey) => {
				return this.crypto.decrypt(aesKey, ivArray, data);
			})
			.then((result) => {
				callback(result);
			})
			.catch((err) => {
				this.onCryptoError(err);
			});
		}
		catch (err) {
			this.onCryptoError(err);
		}
	}

	onCryptoError(err) {
		logger.error(`decrypting error : ${err.message}`);
		if (this.observer) {
			this.observer.trigger(Event.ERROR, {
				type: ErrorTypes.MEDIA_ERROR,
				details: ErrorDetails.FRAG_DECRYPT_ERROR,
				fatal: true,
				reason: err.message,
			});
		}
	}

	destroy() {
		this.observer = null;
		this.config = null;
		this.crypto = null;
		this.cryptoKey = null;
		this.key = null;
	}
}


export default MactrixDecrypter;



// WEBPACK FOOTER //
// ./src/aes/MactrixDecrypter.js